import moduleI18n from './lang';
import menuViewMap from './router/menuViewMap.js';
import moduleRoutes from './router'
import config from './config.js';
import service from './service';

const moduleName = config.moduleName;

export default ({ Vue }) => {
    // 国际化
    Vue.prototype.$addI18n(moduleName, moduleI18n);
    // 注册路由
    Vue.prototype.$addRoutes(moduleName, moduleRoutes);
    // 注册权限
    Vue.prototype.$addMenuViewMap(menuViewMap);
    // 注册service;
    Vue.prototype.$service[moduleName] = service(Vue);
};